import { axios } from '../../../../../utils/settings';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { annualTripDetailsUrl } from '../urls';

export const getAnnualTripDetails = async (manufacturer_id, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${annualTripDetailsUrl()}?manufacturer_id=${manufacturer_id}&company_esi_id=${company_esi_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
